import { authClient } from "../clients/authClient"
import type {
  LoginDto,
  LoginResponseDto,
  ForgotPasswordDto,
  ForgotPasswordResponseDto,
  ResetPasswordDto,
  ResetPasswordResponseDto,
  ChangePasswordDto,
  ChangePasswordResponseDto,
} from "../types/auth.types"

/**
 * Auth Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const authService = {
  /**
   * Login user
   */
  login: async (data: LoginDto): Promise<LoginResponseDto> => {
    try {
      const response = await authClient.login(data)
      
      // Store token and user in localStorage
      localStorage.setItem("auth_token", response.accessToken)
      localStorage.setItem("auth_user", JSON.stringify(response.user))
      
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Request password reset
   */
  forgotPassword: async (data: ForgotPasswordDto): Promise<ForgotPasswordResponseDto> => {
    try {
      const response = await authClient.forgotPassword(data)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Reset password with token
   */
  resetPassword: async (data: ResetPasswordDto): Promise<ResetPasswordResponseDto> => {
    try {
      const response = await authClient.resetPassword(data)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Change password for logged-in user
   */
  changePassword: async (data: ChangePasswordDto): Promise<ChangePasswordResponseDto> => {
    try {
      const response = await authClient.changePassword(data)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default authService
